<template>
  <div
    v-show="loadTicket"
    class="ticket-show-page"
    :class="$vuetify.breakpoint.mdAndDown ? '' : 'fixed-ticketaction-header'"
  >
    <div class="fixed-content top-color pt-3">
      <div class="breadcrumbs pt-1">
        <v-breadcrumbs divider=">" :items="breadcrumbsList">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :to="{ name: item.path }"
              :disabled="item.disabled"
              exact
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </div>
      <h6 class="text-h6 font-weight-600 mb-2 mt-5 d-flex" v-if="ticketDetails.subject">
        <span v-if="ticketDetails.subject.length < 70" class="secondary--font text-truncate d-block ticket-title">
             {{ ticketDetails.subject | upperCaseFirst }} 
        </span>
        <v-tooltip v-else bottom max-width="50%" 
          attach content-class="ticket-subject font-weight-regular"
          >
          <template v-slot:activator="{ on, attrs }">
            <span class="secondary--font text-truncate d-block ticket-title"
              v-bind="attrs"
              v-on="on"
            >{{ ticketDetails.subject | upperCaseFirst }}</span>
          </template>
          <span class="d-block overflow-auto word-break">{{ ticketDetails.subject | upperCaseFirst }}</span>
        </v-tooltip>
        <div
          v-if="permissionCheck"
          class="font-weight-medium text-uppercase ml-2 cursor-pointer mt-n1"
          @click="toggleEditDrawer()"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on"> mdi-pencil </v-icon>
            </template>
            <span>Edit Ticket Details</span>
          </v-tooltip>
        </div>
        <template v-if="ticketAccess.deleted">
          <div class="mt-n1 ml-1">
            <v-icon disabled> mdi-pencil </v-icon>
          </div>
        </template>
      </h6>
      <div class="ticket-actions mt-3 mb-1">
          <ActionButtons
            :ticketDetails="ticketDetails"
            @updateTicket="updateSingleTicket"
          ></ActionButtons>
      </div>
    </div>
    <v-row class="mt-2">
      <v-col cols="12" class="pb-4 pr-1 comment-left-section mt-1" md="8">
        <v-row class="justify-end mb-2">
          <v-col class="d-flex mt-3">
            <template v-if="ticketAccess.deleted && ticketAccess.permissions.create">
              <v-btn
                @click="onRestore()"
                outlined
                class="mr-2 my-1 pa-3 font-weight-bold"
                v-track="'ticket-restore-btn'"
              >
                <v-icon color="#000" size="24" class="mr-1"> mdi-delete-restore </v-icon>
                Restore
              </v-btn>
            </template>
            <reply-buttons :ticketDetails="ticketDetails" :supportEmailList="supportEmailList"
              @show-replysection="showReplySection" :ticketAccess="ticketAccess" />
               
          </v-col>
          <v-col class="justify-end d-flex flex-wrap mr-5 pa-0">
            <v-switch
              v-model="showActivities"
              class="ml-3 mb-0 mr-0"
              color="#03B6FC"
            >
              <template v-slot:label>
                <span class=" pl-0 activities-label">Show Activities</span>
              </template>
            </v-switch>
          </v-col>
        </v-row>
        <v-row no-gutters class="mr-1 scrollable-area">
          <v-col id="comment-section" class="pr-4">
              <CommentSection
                v-if="loadTicket"
                :ticketDetails="ticketDetails"
                :activities="showActivities"
                @commentLoaded="scrollToDown"
                @show-replysection="showReplySection"
                @showThreadSection="displayThreadClick"
                :key="loadCommentSection"
                :ticketAccess="ticketAccess"
              ></CommentSection>
            <div class="ml-60">

              <v-card-actions
                class="pl-0 ml-0 d-inline-block"
                v-if="ticketActionButtons"
              >
                  <div
                    v-if="ticketAccess.deleted"
                    v-show="ticketAccess.permissions.create"
                  >
                    <v-btn
                      @click="onRestore()"
                      outlined
                      class="mr-2 my-1 pa-3 font-weight-bold"
                      v-track="'ticket-restore-btn'"
                    >
                      <v-icon color="#000" size="24" class="mr-1"> mdi-delete-restore </v-icon>
                      Restore
                    </v-btn>
                </div>
                <reply-buttons :ticketDetails="ticketDetails" :supportEmailList="supportEmailList"
              @show-replysection="showReplySection" :ticketAccess="ticketAccess" />
              </v-card-actions>

              <div v-if="replySection" class="mt-10 mt-md-0">
                <reply-editor
                  v-if="replySection"
                  :ticketData="ticketDetails"
                  @oncancel="cancelReplySection"
                  @onReply="loadSingleTicket"
                  @reload_editor="reloadReplyEditor"
                  :supportEmailList="supportEmailList"
                  :ticket-access="ticketAccess"
                  :commentType="selectedReply"
                  :key="selectedReply"
                ></reply-editor>
              </div>
              <template v-if="!ticketAccess.deleted">
                <div
                  class="mt-2"
                  v-if="!loadSupportEmail && supportEmailList.length == 0"
                >
                  <v-alert
                    icon="mdi-alert-circle-outline"
                    dense
                    color="#FFCDD2"
                    class="width-100 body-2 mb-0 pa-2 pl-3 error-icon-color"
                  >
                    You can not reply to this query/ticket because your support
                    email id is not setup or verified.
                  </v-alert>
                </div>
                <div
                  v-if="ticketAccess.contactRemoved && !ticketAccess.closed"
                  class="mt-2"
                >
                  <v-alert
                    icon="mdi-alert-circle-outline"
                    dense
                    color="#FFCDD2"
                    class="width-100 body-2 mb-0 pa-2 pl-3 error-icon-color"
                  >
                  The contact linked with this ticket has been deleted and
                  you will not be able to reply to the associated email address.
                  </v-alert>
                </div>
              </template>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="right-side-ticket px-0 pt-0">
        <div v-if="forwardSection || threadSection || tagSection || orderSection" class="mt-1 fill-height white">
           <div class="d-flex justify-space-between flex-wrap pa-5 pt-6 pb-2 pl-4  border-bottom">
              <div class="font-weight-600 pa-0 text-capitalize secondary--font mt-1 text-h7">
                <span class="secondary--font">{{sectionHeading}}</span>
              </div>
              <div class="d-flex flex-wrap" @click="closeThreadSection()">
                <v-btn text icon>
                  <v-icon class="cursor-pointer"> mdi-close </v-icon>
                </v-btn>
              </div>  
            </div>
            <div class="right-side-scroll" id="section-scrolldiv">
          <!--- tags and customer order --->
            <div class="mr-3 ml-4" v-if="tagSection || orderSection">
              <TicketTags v-if="tagSection" :tags="ticketDetails.tags" @update-tags="updateTags" :ticket-access="ticketAccess" />
              <commerce-details v-else-if="orderSection" :key="ticketDetails.contact_email" :contactEmail="ticketDetails.contact_email" />
            </div>

            <thread-section 
            v-else-if="threadSection"
            :ticketData="ticketDetails"
            :supportEmailList="supportEmailList"
            :threadId="singleThreadId"
            :key="singleThreadId"
            @reloadCommentSection="
            loadCommentSection = !loadCommentSection"
            :ticketAccess="ticketAccess"> 
            </thread-section>

            <reply-editor
              v-else-if="forwardSection"
              :ticketData="ticketDetails"
              :selectedCommentId="selectedCommentId"
              @oncancel="cancelForwardSection"
              @onReply="loadSingleTicket"
              @showThreadSection="displaySection"
              :supportEmailList="supportEmailList"
              :selectedAction="selectedAction"
              :ticket-access="ticketAccess"
              :commentType="selectedReply"
              :key="selectedReply">
            </reply-editor>

            </div>
        </div>
         <div v-else class="pl-2 mt-8">
          <right-side-section
            :ticketDetails="ticketDetails"
            :ticket-access="ticketAccess"
            @reloadTicket="getSingleTicket($route.params.id)"
            @showSection="displaySection"
          />
        </div>
      </v-col>
    </v-row>
    <v-overlay :value="!loadTicket">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    
    <EditTicket
      v-if="editDrawerToggle"
      :showDrawer="editDrawerToggle"
      :ticketDetails="this.ticketDetails"
      @reloadTicket="getSingleTicket($route.params.id)"
      :key="reloadCmp"
    ></EditTicket>

    <!-- Restore selected ticket dialog -->
    <dialog-box v-bind="dialog.attrs" v-on="dialog.on" />
  </div>
</template>

<script>
import { $mailbox, $tickets } from "@/services/Index";
import { ticketMixin } from "@/mixins/ticket";
import EditTicket from "@/components/tickets/EditTicket";
import CommentSection from "@/components/tickets/reply/CommentSection";
import ShowAttachments from "@/components/tickets/reply/ShowAttachments";
import ActionButtons from "@/components/tickets/TicketDetailActions";
import RightSideSection from "@/components/tickets/RightSideSection";
import ReplyButtons from "@/components/tickets/ReplyButtons";
import { mapGetters } from "vuex";
import DialogBox from "@core/components/ui/DialogBox";
import ThreadSection from '@/components/tickets/reply/ThreadSection';
import TicketTags from "@/components/tags/TicketTags";
import CommerceDetails from "@/components/commerce/Details";
import ReplyEditor from '@/components/tickets/reply/ReplyEditor';


export default {
  name: "SingleTicket",
  mixins: [ticketMixin],
  components: {
    EditTicket,
    CommentSection,
    ShowAttachments,
    ActionButtons,
    RightSideSection,
    DialogBox,
    ReplyButtons,
    ThreadSection,
    TicketTags,
    CommerceDetails,
    ReplyEditor
  },
  data() {
    return {
      ticketActionButtons: true,
      priorityToggle: false,
      ticketId: this.$route.params.id,
      breadcrumbsList: [
        {
          text: "All Tickets",
          disabled: false,
          path: "tickets",
        },
        {
          text: `#${this.$route.params.id}`,
          disabled: true,
          path: "",
        },
      ],
      loadTicket: false,
      ticketDetails: {},
      transparent: "rgba(0, 0, 0, 0.5)",
      filePreviewDialog: false,
      previewFile: {},
      listOfComments: [],
      selectedReply: "",
      editDrawerToggle: false,
      reloadCmp: false,
      supportEmailList: [],
      showActivities: false,
      loadSupportEmail: false,
      newTags: [],
      selectedCommentId:null,
      tagSection: false,
      orderSection: false,
      replySection: false,
      forwardSection: false,
      threadSection: false,
      sectionHeading: "Threads",
      dialog: {
        attrs: {
          show: false,
          title: "Restore Ticket",
          loading: false,
          confirmBtn: true,
          confirmationText: "Restore",
        },
        on: {
          confirm: this.onConfirm,
          cancel: () => {
            this.dialog.attrs.show = false;
          },
        },
      },
      selectedAction:null,
      singleThreadId: null,
      loadCommentSection:false
    };
  },

  computed: {
    ...mapGetters({
      account: ["auth/account"],
    }),
    associatedField() {
      return this.$store.getters["tickets/associatedField"];
    },
    permissionCheck() {
      return !this.ticketAccess.closed && !this.ticketAccess.deleted && this.ticketAccess.permissions.create
    },   
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.getSingleTicket(id);
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.customClassHandler('add')
    this.getSupportEmails();
  },

  methods: {

    reloadReplyEditor(commentType){
      this.selectedReply = commentType
    },
    /* eslint-disable */
    async getSingleTicket(ticketId) {
      this.loadTicket = false;
      try {
        const response = await $tickets.fetchSingle(ticketId, {});
        if (response.data) {
          this.ticketDetails = response.data;
          this.breadcrumbsList[1].text = `#${this.ticketDetails.id}`;
          this.loadTicket = true;
        }
      } catch (error) {
        if (error.response) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Invalid Ticket",
              message: this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(error.response.data).subjectText()} `,
              }),
              type: "error",
            },
          ]);
          this.$router.push({ name: "tickets" }).catch((err) => {});
        }
      }
    },

    async updateSingleTicket(ticket, name, value, actionName) {
      if(ticket[name] !== value) { // will not update current selected action item
        await this.performAction(
          ticket,
          name,
          value,
          "single-page",
          actionName
        );
        this.getSingleTicket(ticket.id);
      }
    },

    getPreviewFile(file) {
      if (file.file_type !== "application/msword") {
        this.previewFile = file;
        this.filePreviewDialog = true;
      }
    },

    async closeTicketClick() {
      this.replySection = false;
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        await this.confirmClose();
        setTimeout(() => {
          this.getSingleTicket(this.$route.params.id);
        }, 300);
      }
    },

    showReplySection(reply, commentId = '') {
      this.selectedReply = reply;
      if(reply !== 'forward' && reply !== 'forward_ticket') {
        this.displaySection('ticket_reply')
        this.scrollToDown()
      }
      else {
        this.selectedCommentId = commentId
        this.selectedAction = reply
        this.displaySection('forward')
      }
    },

    cancelReplySection() {
      this.replySection = false;
      this.ticketActionButtons = true;
    },

    cancelForwardSection() {
      this.forwardSection = false;
    },

    closeThreadSection() {
      this.forwardSection = false;
      this.threadSection = false;
      this.tagSection = false;
      this.orderSection = false;
    },

    loadSingleTicket() {
      if (this.ticketDetails.id) {
        this.getSingleTicket(this.ticketDetails.id);
      }
    },

    toggleEditDrawer() {
      this.reloadCmp = !this.reloadCmp;
      this.editDrawerToggle = true;
    },

 // scrolling down to bottom onclick of top reply and note button

    scrollToDown() {
      setTimeout(function () {
        let element = document.getElementById("comment-section");
        element.scrollTop = element.scrollHeight;
      }, 1000);
    },

    async getSupportEmails() {
      const data = {};
      try {
        this.loadSupportEmail = true;
        const response = await $mailbox.fetchList(data, {});
        if (response.data) {
          this.loadSupportEmail = false;
          this.supportEmailList = response.data.mailboxes.filter((email) => {
            return email.verified_at !== null;
          });
        }
      } catch (error) {
        this.loadSupportEmail = false;
      }
    },

    /** add/remove custom class for handling scrollbar **/
    customClassHandler(action) {
        var elements = document.getElementsByClassName("vertical-stretch");
        for (let i = 0; i < elements.length; i++) {
          if(action == 'add'){ elements[i].classList.add("ticket-detail-page");}
          else { elements[i].classList.remove("ticket-detail-page"); }
        }
    },
    
    displaySection(currentSection) {
      switch (currentSection) {
        case 'threads':
          this.threadSection = true;
          this.singleThreadId = null;
          this.sectionHeading = "Threads";
          break;
        case 'tags':
          this.tagSection = true;
          this.sectionHeading = "Tags";
          break;
        case 'orders':
          this.orderSection = true;
          this.sectionHeading = "Customer Orders";
          break;
        case 'forward':
          this.orderSection = false;
          this.tagSection = false;
          this.threadSection = false;
          this.forwardSection = true;
          this.replySection = false
          this.sectionHeading = "Threads";
          this.ticketActionButtons = true;
          break;
        case 'ticket_reply':
          this.forwardSection = false;
          this.ticketActionButtons = false;
          this.replySection = true
          break;
        default:
          break;
      }
    },

    displayThreadClick(threadId){
      this.displaySection('threads')
      this.singleThreadId = threadId
    },

    updateTags(tags, selected) {
      this.ticketDetails.tags = selected;
      const payload = { ticket: { tag_ids: tags } };
      $tickets.update(payload, this.ticketId, {}).then((response) => {
        this.$emit("reloadTicket");
        this.$store.dispatch("ui/snackbar", [{ message: `Tag has been updated`, type: "success" }]);
      }).catch((error) => {
        this.$store.dispatch("ui/snackbar", [{ message: `There was an error assigning the tag. Please try again.`, type: "error" }]);
      });
    },
    /**
     * @Description
     * Display the restore confirmation modal box before actually restoring the ticket.
     */
    onRestore() {
      this.dialog.attrs.subtitle = `Are you sure you want to restore the ticket?`;
      this.dialog.attrs.show = true;
    },
    /**
     * @description
     * Handles the confirmation of ticket restore by first initiating the restore process,
     * indicating loading status, and then closing the dialog box.
     */
    onConfirm() {
      this.dialog.attrs.loading = true;
      // Manage payload for tickets restore API Call
      const payload = {
        ids: [this.ticketDetails.id]
      }
      $tickets.restore(payload, {}).then((response) => {
        this.$store.dispatch("ui/snackbar", [{
          message: `Ticket restored successfully.`,
          type: "success",
        }]);
        this.$router.push({ name: "tickets-trash" });
      }).catch((error) => {
        this.$store.dispatch("ui/snackbar", [
          {
            message: this.$errors(error.response.data).msg({
              capitalize: false,
              prepend: `${this.$errors(
                error.response.data
              ).subjectText()} `,
            }),
            type: "error",
          },
        ]);
      }).finally(() => {
        this.dialog.attrs.loading = false;
        this.dialog.attrs.show = false;
      })
    },
     showThreadSection(){
      this.threadSection = true;
    }
  },

  destroyed() {
    this.customClassHandler('remove')
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/ticket-detail.scss";
</style>

